import { sendGenerateQuestionsFromAoIEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class GenerateQuestionsFromAoIAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendGenerateQuestionsFromAoIEvent;

  constructor(data: GenerateQuestionsFromAoIEventData) {
    super();
    this.eventData = data;
  }
}

export type GenerateQuestionsFromAoIEventData = {
  num_aoi_generated: number;
  num_aoi_selected: number;
  num_questions_to_generate: number;
  generate_explanations: boolean;
};
